<cap-elss-header *ngIf="isCommitteeMember"></cap-elss-header>
<div [ngClass]="{ 'hidden-md' : isCommitteeMember }">
    <app-header></app-header>
</div>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-loader *ngIf="loader"></app-loader>